import React, { useState } from 'react';
import './aiExport.css';
import BASE_URL from "../../config";

// TEMPORARY -- AI interaction log export, added 2026-08-06. See
// REMOVE_ai_interaction_export.md at the repo root. Lets an admin pick a
// date range and download a CSV of every voice-assistant request/response
// pair for that period, for manual review. Remove this whole page (plus
// the sidebar entry in components/sideBar/sidebar.js and the route in
// App.js) when the review period is over.
const AiExport = () => {
    const todayStr = new Date().toISOString().slice(0, 10);

    const [startDate, setStartDate] = useState(todayStr);
    const [endDate, setEndDate] = useState(todayStr);
    const [exporting, setExporting] = useState(false);
    const [statusMsg, setStatusMsg] = useState(null); // { type: 'ok' | 'err', text }

    const handleExport = async () => {
        if (!startDate || !endDate) {
            setStatusMsg({ type: 'err', text: 'Pick both a start and end date.' });
            return;
        }
        if (startDate > endDate) {
            setStatusMsg({ type: 'err', text: 'Start date must be on or before the end date.' });
            return;
        }

        setExporting(true);
        setStatusMsg(null);

        try {
            const res = await fetch(
                `${BASE_URL}/api/ai-export/export/?start=${startDate}&end=${endDate}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
                    },
                }
            );

            if (!res.ok) {
                let detail = '';
                try {
                    const data = await res.json();
                    detail = data.error || '';
                } catch {
                    // response wasn't JSON, ignore
                }
                throw new Error(detail || `Export failed (${res.status})`);
            }

            const blob = await res.blob();
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `ai_interactions_${startDate}_to_${endDate}.csv`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);

            setStatusMsg({ type: 'ok', text: 'Export downloaded.' });
        } catch (err) {
            setStatusMsg({ type: 'err', text: err.message || 'Failed to export. Please try again.' });
        } finally {
            setExporting(false);
        }
    };

    return (
        <div className="aws-dashboard ai-export-page">
            <div className="aws-header">
                <div className="header-content">
                    <p className="aws-subtitle">Temporary tool</p>
                    <h1 className="aws-title">AI Interaction Log Export</h1>
                    <p className="aws-subtitle">
                        Download a CSV of what users asked the voice assistant and what it
                        replied, for a chosen date range. For manual review only -- this
                        tool will be removed later.
                    </p>
                </div>
            </div>

            <div className="ai-export-content">
                <div className="ai-export-panel">
                    <h2>Export by date range</h2>
                    <p className="ai-export-hint">
                        Includes every recognized customer, device UID, request, and the
                        assistant's response within the selected range (inclusive).
                    </p>

                    <div className="ai-export-form-row">
                        <label className="ai-export-field">
                            <span>From</span>
                            <input
                                type="date"
                                value={startDate}
                                max={endDate || undefined}
                                onChange={(e) => setStartDate(e.target.value)}
                            />
                        </label>
                        <label className="ai-export-field">
                            <span>To</span>
                            <input
                                type="date"
                                value={endDate}
                                min={startDate || undefined}
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                        </label>
                        <button
                            className="ai-export-btn"
                            disabled={exporting}
                            onClick={handleExport}
                        >
                            {exporting ? 'Exporting…' : 'Export'}
                        </button>
                    </div>

                    {statusMsg && (
                        <div className={`ai-export-status ${statusMsg.type === 'ok' ? 'ai-export-status-ok' : 'ai-export-status-err'}`}>
                            {statusMsg.text}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AiExport;
